module.exports = "/_next/static/images/financial-accounting-service-1-9a794afe1f9c9eea549ff5a6a5904574.webp";